/** Estilos embebidos en el portal — no dependen del orden del CSS global ni del tema oscuro. */
export const ROUTINE_CLASS_EDITOR_MODAL_CSS = `
.routine-class-editor-island,
.routine-class-editor-island section,
.routine-class-editor-island .routine-class-editor-island__section {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #0f172a !important;
  border-color: #e2e8f0 !important;
}

.routine-class-editor-island :is(
  h1, h2, h3, h4, h5, legend,
  label, span, p, strong, em, small, div
) {
  color: #0f172a !important;
  opacity: 1 !important;
}

.routine-class-editor-island .rcel-muted {
  color: #64748b !important;
  opacity: 1 !important;
}

.routine-class-editor-island label.inline-flex {
  background: #f8fafc !important;
  color: #0f172a !important;
  border: 1px solid #cbd5e1 !important;
}

.routine-class-editor-island :is(
  .input,
  input:not([type='color']):not([type='checkbox']):not([type='radio']),
  select,
  textarea
) {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #0f172a !important;
  border: 1px solid #cbd5e1 !important;
  color-scheme: light;
}

.routine-class-editor-island .btn-primary {
  background: #0f172a !important;
  color: #ffffff !important;
  border-color: #0f172a !important;
}

.routine-class-editor-island .btn-secondary {
  background: #ffffff !important;
  color: #0f172a !important;
  border: 1px solid #94a3b8 !important;
}

.routine-class-editor-island .text-red-600 {
  color: #b91c1c !important;
}
`;
